import { Selector } from '@ngxs/store';

import { BcStateContext } from '@bayclubs/state';
import { FeaturesModel } from '@bayclubs/employee-management-api';

import { FeaturesStateModel } from './features.state.model';
import { FeaturesState } from './features.state';


export class FeaturesSelectors {
    @Selector([FeaturesState])
    static getFeatures(state: FeaturesStateModel): BcStateContext<FeaturesModel> {
        return state.features;
    }

    @Selector([FeaturesState])
    static getSemiPrivatePackagesEnabled(state: FeaturesStateModel) {
    
        if (!state.features?.data) {
            return null;
        }

        return state?.features?.data?.flags?.OfficeSemiPrivatePackagesEnabled ?? false;
    }

}
